import { AppBar, Box } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import { AgreementPassportDialog } from "./AgreementPassportDialog";

export const AgreementPassportDialogPage = () => {
    const { id } = useParams();

    if (!id) {
        return null;
    }

    const handleClose = () => {
        window.close();
    };

    return (
        <Box
            sx={{
                height: "100vh",
                width: "100vw",
                padding: 0,
                margin: 0,
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "background.default",
            }}
        >
              
            <AgreementPassportDialog open={true} onClose={handleClose} agreementId={id} />
          
        </Box>
    );
};
